export default __webpack_public_path__ + "static/media/nft_image_2.f8fc58b3.png";